import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

import Header from './components/Header';
import Loader from './components/Loader';
import LoginPage from './pages/LoginPage';
import SurveyPage from './pages/SurveyPage';
import ThankYouPage from './pages/ThankYouPage';
import SurveyCompletedPage from './pages/SurveyCompletedPage';
import AdminPage from './pages/AdminPage';
import AdminSurveyDetailPage from './pages/AdminSurveyDetailPage';
import SuperAdminDashboard from './pages/SuperAdminPage';
import AddSurvey from "./pages/addSurvey.jsx";
import SurveyInvitePage from "./pages/InviteParticipantsPage";
import SurveyExpiredPage from "./pages/SurveyExpiredPage";
import DynamicPPTBuilder from "./components/DynamicPPTDownload.jsx";
import FivesResult from "./pages/5sResult"; // adjust path as needed
import VakSurvey from "./pages/VakSurvey"; // adjust path as needed
import CPQResult from "./pages/CPQResult"; // adjust path as needed
import EMSResult from "./pages/EMSResult.jsx"; // adjust path as needed
import JHResult from "./pages/JHResult.jsx"; // adjust path as needed
import TKResult from "./pages/TKResults.jsx"; // adjust path as needed
import AOResults from './pages/AOResults.jsx';
import NSResult from './pages/NSResult.jsx';
import LocoResults from './pages/LocoResults.jsx';
import T90Report from './pages/T90Report.jsx';

// Inside your <Routes> block:
<Route path="/5s-result" element={<FivesResult />} />

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) return <Loader text="Loading..." />;

  return (
    <>
      <Header />
      <Routes>
        {/* ✅ Public routes (accessible without login) */}
        <Route path="/expired" element={<SurveyExpiredPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/survey/:surveyId" element={<SurveyPage />} />
        <Route path="/survey-completed" element={<SurveyCompletedPage />} />
        <Route path="/5s-result" element={<FivesResult />} />
        <Route path="/vak-survey-result" element={<VakSurvey />} />
        <Route path="/cpq-result" element={<CPQResult />} />
        <Route path="/ems-result" element={<EMSResult />} />
        <Route path="/jh-result" element={<JHResult />} />
        <Route path= "/tk-result" element={<TKResult />} />
        <Route path="/ao-result" element={<AOResults />} />
        <Route path="/ns-result" element={<NSResult />} />
        <Route path="/loco-results" element={<LocoResults />} />
        <Route path="/t90-results" element={<T90Report />} />
        {/* ✅ Protected routes (require login) */}
        {!user ? (
          <Route path="*" element={<LoginPage />} />
        ) : (
          <>
            {/* <Route path="/" element={<SurveyListPage />} /> */}
            <Route path="/admin/surveyinvite/:surveyId/company/:companyId/invite" element={<SurveyInvitePage />}/>
            {user.role === "Admin" && (
        
              <>
              <Route
                  path="/"
                  element={<AdminPage companyId={user.company_fk} />}
                />
                <Route
                  path="/admin"
                  element={<AdminPage companyId={user.company_fk} />}
                />
                <Route
                  path="/admin/survey/:surveyId"
                  element={<AdminSurveyDetailPage companyId={user.company_fk}/>}
                />
                <Route
                  path="/add-survey"
                  element={<addSurvey companyId={user.company_fk} />}
                />
              </>
            )}

            {user.role === "SuperAdmin" && (
             <>
             <Route path="/" element={<SuperAdminDashboard/>}/>
             <Route path="/superadmin/dashboard" element={<SuperAdminDashboard />} />
             <Route path="/superadmin/survey-generateppt/:surveyId/company/:companyId" element={<DynamicPPTBuilder />}/>
             <Route path="/add-survey" element={<AddSurvey />}/>
             <Route path="/invite/:surveyId/:companyId" element={<SurveyInvitePage />} />
             </>
            )}
          </>
        )}
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}